import { Leaf, Users, Shield } from "lucide-react";
import { useTran } from "@/hooks";

const ESGSustainabilityStrategy = ({ strategy }) => {
  const { t } = useTran();
  const pillars = [
    {
      key: "environmental",
      title: t("Environmental Focus"),
      icon: Leaf,
      color: "#10b981",
      bgColor: "#d1fae5",
    },
    {
      key: "social",
      title: t("Social Responsibility"),
      icon: Users,
      color: "#8b5cf6",
      bgColor: "#ede9fe",
    },
    {
      key: "governance",
      title: t("Governance Commitments"),
      icon: Shield,
      color: "#f59e0b",
      bgColor: "#fef3c7",
    },
  ];

  return (
    <div className="esg-page-break esg-avoid-break bg-white p-12">
      <h2 className="mb-8 text-3xl font-bold text-slate-900">
        {t("Sustainability Strategy")}
      </h2>

      <div className="mb-10 rounded-lg border border-slate-200 bg-slate-50 p-6">
        <p className="text-base text-slate-700 leading-relaxed">
          {strategy.overview}
        </p>
      </div>

      <div className="space-y-8">
        {pillars.map((pillar) => {
          const Icon = pillar.icon;
          const items = strategy[pillar.key] || [];

          return (
            <div key={pillar.key} className="esg-strategy-pillar">
              <div className="mb-4 flex items-center gap-3">
                <div
                  className="pillar-icon flex h-10 w-10 items-center justify-center rounded-lg"
                  style={{ backgroundColor: pillar.bgColor }}
                >
                  <Icon className="h-6 w-6" style={{ color: pillar.color }} />
                </div>
                <h3
                  className="text-xl font-bold"
                  style={{ color: pillar.color }}
                >
                  {pillar.title}
                </h3>
              </div>
              <ul className="esg-strategy-list ml-12 space-y-2">
                {items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-sm text-slate-700"
                  >
                    <span
                      className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full"
                      style={{ backgroundColor: pillar.color }}
                    />
                    <span className="flex-1">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="mt-10 rounded-lg border border-blue-200 bg-blue-50 p-4">
        <p className="text-sm text-blue-900 leading-relaxed">
          <span className="font-semibold">{t("Our commitment")}:</span>{" "}
          {t(
            "These strategic priorities guide decision-making, risk management, and stakeholder engagement.",
          )}
        </p>
      </div>
    </div>
  );
};

export default ESGSustainabilityStrategy;
